export default __webpack_public_path__ + "static/media/dash_6.80253dfe.png";